export default function popUp() {
  var popup = document.getElementById('myPopup');
  popup.classList.toggle('block');
}
